'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenuTrigger } from '@react-aria/menu';
import { useListState } from '@react-stately/list';
import { useMenuTriggerState } from '@react-stately/menu';
import { useRef, useMemo } from 'react';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { SwanListboxButtonContext } from './listbox-button.context.js';
import { useListboxList, SwanListboxListContext } from './listbox-list.context.js';
import { SwanPopoverContextProvider, useSwanPopover } from '../popover/popover.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let f = tokensRaw.SwanBaseFontLineHeight500 * parseFloat(tokensRaw.SwanBaseFontSize100), O = 2 * parseFloat(tokensRaw.SwanCompListboxOptionPaddingVertical), m = parseFloat(tokensRaw.SwanSemSpace1), j = parseFloat(tokensRaw.SwanCompListboxPadding);
const HEIGHT_OF_OPTIONS_TO_SHOW = 6.5 * (f + O + m) + j;
function SwanListboxContextProviderInner(o) {
    let { children: p, disabled: l, skin: s, selectionProps: f } = o, { triggerRef: O, triggerProps: m, overlayState: j } = useSwanPopover(), { menuTriggerProps: y, menuProps: d } = useMenuTrigger(_object_spread_props(_object_spread({}, m), {
        isDisabled: l,
        type: 'listbox'
    }), j, O), g = useMemo(()=>({
            skin: s,
            triggerProps: y,
            triggerDisabled: null != l && l
        }), [
        y,
        l,
        s
    ]), { childItems: w, items: P, disabledKeys: S } = useCollectionContext(), x = useMemo(()=>{
        let e = null != f ? f : {}, { onSelectionChange: t } = e, r = _object_without_properties(e, [
            "onSelectionChange"
        ]);
        return _object_spread_props(_object_spread({}, d, r), {
            disabledKeys: S,
            onSelectionChange: (e)=>{
                null != t && t(e), 'multiple' !== r.selectionMode && j.close();
            }
        });
    }, [
        S,
        d,
        j,
        f
    ]), h = useRef(null), v = useListState(_object_spread_props(_object_spread({}, x), {
        items: P,
        children: w
    })), H = useListboxList(x, h, v);
    return jsx(SwanListboxButtonContext.Provider, {
        value: g,
        children: jsx(SwanListboxListContext.Provider, {
            value: H,
            children: p
        })
    });
}
function SwanListboxContextProvider(t) {
    let { fullWidth: r, maxHeight: c } = t, l = _object_without_properties(t, [
        "fullWidth",
        "maxHeight"
    ]), a = useMenuTriggerState({}), u = useRef(null), b = useRef(null), _ = useModeExtractor(b, a.isOpen);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                popoverRef: u,
                triggerRef: b,
                overlayState: a,
                overlayProps: {},
                triggerProps: {},
                fullWidth: r,
                modes: _,
                maxHeight: null != c ? c : HEIGHT_OF_OPTIONS_TO_SHOW
            }), [
            a,
            r,
            _,
            c
        ]),
        children: jsx(SwanListboxContextProviderInner, _object_spread({}, l))
    });
}

export { HEIGHT_OF_OPTIONS_TO_SHOW, SwanListboxContextProvider };
